import { NextImage, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import styles from './HighlightItem.module.scss';

type Props = {
  fields: {
    description: {
      value: string;
    };
    icon: {
      value: string;
    };
    title: {
      value: string;
    };
  };
  numberOfItems: number;
};

const HighlightItem = ({ fields, numberOfItems }: Props) => {
  const numberClass = `${styles[`layout-${numberOfItems}`]}`;
  const addLayoutLess = numberOfItems === 3 || numberOfItems === 1 ? styles['layout-less'] : '';

  return (
    <div className={`${styles['highlight-item']} p-2 ${numberClass} ${addLayoutLess}`}>
      <div className={styles['highlight-item__title']}>
        <NextImage
          field={fields.icon}
          className={`me-2 flex-shrink-0 ${styles['highlight-item__icon']} background-to-change`}
          width={50}
          height={50}
        />
        <Text
          tag="h3"
          field={fields.title}
          className="text-grey background-to-change text-nowrap"
        />
      </div>
      <div className={styles['highlight-item__content']}>
        <Text tag="p" field={fields.description} className="text-grey background-to-change" />
      </div>
    </div>
  );
};

export default HighlightItem;
